import React, { useContext, useEffect, useRef, useState } from "react";
import { Calendar } from "react-multi-date-picker";
import AppContext from "../context/AppContext";
const DateField = ({ field, label, onChange, children, minDate, maxDate, ...rest }) => {
   const { registerPopupListener, popupCloseEvent } = useContext(AppContext);
   const [value, setValue] = useState();
   const refEl = useRef();
   const [show, setShow] = useState(false);
   const onDateSelected = (d) => {
      let val = d.toDate().toISOString().split("T")[0];
      setValue(val);
      onChange && onChange({ name: field, value: val });
   };
   const clearPopups = () => {
      for (let d of document.querySelectorAll(".easyota-form-plugin .date-select")) {
         d.classList.remove("show");
      }
      setShow(false);
   };
   const handleShowHide = (ev) => {
      ev.stopPropagation();
      ev.preventDefault();
      if (ev.target.classList.contains("sd")) {
         clearPopups();
      } else {
         popupCloseEvent();
         refEl.current.classList.add("show");
         setShow(true);
      }
   };
   useEffect(() => {
      document.addEventListener("click", (ev) => {
         clearPopups();
      });
      registerPopupListener(() => {
         clearPopups();
      });
   }, [registerPopupListener]);
   return (
      <div className='field'>
         <label htmlFor={field} className='pos-relative label' onClick={handleShowHide}>
            {label}
            <input
               {...rest}
               className='date'
               type='text'
               name={field}
               id={field}
               readOnly={show}
               placeholder='Add date'
               defaultValue={value ? new Date(Date.parse(value)).toLocaleString("en-UK").split(",")[0] : undefined}
            />
            <div ref={refEl} className='date-select'>
               <Calendar
                  numberOfMonths={1}
                  disableMonthPicker
                  disableYearPicker
                  onChange={onDateSelected}
                  minDate={minDate}
                  maxDate={maxDate}
               />
            </div>
         </label>
      </div>
   );
};

export default DateField;
